module.exports = __webpack_public_path__ + "static/assets/6b18df39aa731f51105914cb3879478e.svg";